module.exports = __webpack_public_path__ + "static/media/prop-7-thumb.305fb94e.webp";